import { useState } from 'react';
import { ApiProductStatus } from '@ibk/shared-types';
import { useAppSelector } from '../store/hooks';
import { selectContaDigitalProduct } from '../store/selectors/productsSelectors';
export function useAccountBalance() {
    const [error] = useState(null);
    const contaDigitalData = useAppSelector(selectContaDigitalProduct);
    const isContaActive = contaDigitalData?.data?.status === ApiProductStatus.ACTIVE;
    const isLoading = contaDigitalData?.isLoading || false;
    const rawBalance = contaDigitalData?.data?.metadata?.balance?.amount;
    const balance = typeof rawBalance === 'number' ? rawBalance : 0;
    const hasAccount = isContaActive && Boolean(rawBalance);
    return {
        balance,
        hasAccount,
        isLoading,
        error,
    };
}
